import { useState } from "react";
import "./index.css";
import type { Parfume, Formula } from "../AdminFormulaTable";
import Mockup from "../../routes/Mockup";

type Accord = { phase: "top"|"heart"|"base"; ingredient: string; drops?: number };

function phaseLabel(ph: Accord["phase"]) {
  if (ph === "top") return "Верхние ноты";
  if (ph === "heart") return "Сердце";
  if (ph === "base") return "База";
  return ph;
}

export default function AdminParfumeModal({
  parfume,
  onClose,
  onSave,
}: {
  parfume: Parfume;
  onClose: () => void;
  onSave: (patch: Partial<Parfume>) => void | Promise<void>;
}) {
  const [name, setName] = useState(parfume.name || "");
  const [img, setImg] = useState(parfume.img || "");
  const [description] = useState(parfume.description || ""); // ассоциацию не редачим
  const [style, setStyle] = useState<string>(parfume.formula?.style || "");
  const [details, setDetails] = useState<string>(parfume.formula?.details || "");
  const accords = (parfume.formula?.accords || []) as Accord[];

  async function handleSave() {
    const patch: Partial<Parfume> = {
      name,
      img,
      formula: { ...(parfume.formula || {} as Formula), style, details },
    };
    await onSave(patch);
  }

  return (
    <div className="modal">
      <div className="modal__box">
        <div className="modal__head">
          <div className="modal__title">Редактирование парфюма</div>
          <button className="btnX" onClick={onClose} aria-label="Закрыть">×</button>
        </div>

        <div className="grid2">
          <div className="left">
            <Mockup title={name || ""} photoUrl={img || ""} />
            <div className="modal__title">{name}</div>
            <div className="lbl">{description}</div>
          </div>

          <div className="right">

            <label className="lbl">Стиль</label>
            <input className="inp" value={style} onChange={(e)=>setStyle(e.target.value)} placeholder="кратко" />

            <label className="lbl">Детали для клиента</label>
            <textarea className="inp-textarea" rows={4} value={details} onChange={(e)=>setDetails(e.target.value)} placeholder="понятное описание для человека" />

            <div className="lbl">Формула</div>
            <div className="accords">
              {accords.map((a, i) => (
                <div className="accord" key={i}>
                  <span className={`phase phase--${a.phase}`}>{phaseLabel(a.phase)}</span>
                  <span className="ing">{a.ingredient}</span>
                  {typeof a.drops === "number" && <span className="qty">{a.drops} кап.</span>}
                </div>
              ))}
              {accords.length === 0 && <div className="muted">нет ингредиентов</div>}
            </div>
          </div>
        </div>

        <div className="modal__actions">
          <button className="btn btn--ghost" onClick={onClose}>Отмена</button>
          <button className="btn btn--primary" onClick={handleSave}>Сохранить</button>
        </div>
      </div>
    </div>
  );
}
